// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"ea3246e9","787":"e513e7d6"}[chunkId] + ".chunk.js";
};